import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'src/contexts/auth';
import Layout from 'src/layout';
import 'src/bootstrap/extra/icons.font';
import { ToastProvider } from 'src/contexts/toast';
import MuiRTL from 'src/theme/mui/rtl';
import MuiTheme from 'src/theme/mui/theme';

function App({ router = null as any, routerProps = {} as any }) {
	const Router = router ?? BrowserRouter;

	return (
		<Router {...routerProps}>
			<MuiRTL>
				<MuiTheme>
					<ToastProvider>
						<AuthProvider>
							<Layout />
						</AuthProvider>
					</ToastProvider>
				</MuiTheme>
			</MuiRTL>
		</Router>
	);
}

export default App;
